
export const gridMargin = { margin : '5px 0px' };